import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "btnCSV",
  type: "button",
  class: "btn btn-primary",
  "data-toggle": "modal",
  "data-target": "#selectCSV"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-alt" }, null, -1)
const _hoisted_3 = {
  class: "modal fade",
  tabindex: "-1",
  id: "selectCSV",
  role: "dialog"
}
const _hoisted_4 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = {
  type: "button",
  id: "modalAddClose",
  class: "close",
  ref: "modalDismiss",
  "data-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = { class: "form-row mb-3" }
const _hoisted_13 = { class: "col col-4" }
const _hoisted_14 = {
  class: "my-1 mr-2",
  for: "vocabList"
}
const _hoisted_15 = { class: "col col-8" }
const _hoisted_16 = {
  ref: "vocabFile",
  "data-toggle": "tooltip",
  "data-placement": "top",
  title: "Tooltip on top",
  type: "file",
  name: "file",
  placeholder: "Vokabeln.csv",
  accept: ".csv, .CSV",
  class: "form-control",
  id: "vocabList",
  multiple: ""
}
const _hoisted_17 = { class: "modal-footer" }
const _hoisted_18 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t("messages.add csv")), 1),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t("messages.add csv")), 1),
            _createElementVNode("button", _hoisted_8, _hoisted_10, 512)
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("messages.Choose a file")), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("input", _hoisted_16, null, 512)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.$t("messages.Upload vocabulary")), 1)
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}